import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import getQueryClient from "../../queryClient";
import { allKontakReferensiKey } from "./useFetchKontakReferensi";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";

export async function removeKontakReferensi(ID: number) {
    const res = await ApiClient.delete(
        `/RemoveReferenceContact/${ID}`
    );
    return res.data;
}

export const useRemoveKontakReferensi = mutationWrapper(removeKontakReferensi, {
    onSuccess: () => {
        getQueryClient().invalidateQueries(allKontakReferensiKey);
        getQueryClient().invalidateQueries(checkProfileKey)
    },
});
